import React, { useState } from 'react';
import styled from 'styled-components';
import ModalPath from '../modal/ModalPath';

//캠페인 하단
export default function Groupfooter({
  userInfo,
  joinModal,
  leaveModal,
  bottomTxt,
  showModalNext,
  bottomTxtafer,
  bgcolor,
  color,
  join,
  showModalNextjoin,
  setModalOption,
  setModalShow,
}) {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      {join.is_member ? ( //member 일때
        showModalNextjoin ? ( //탈퇴하기 누르고 나서
          <Campaignfooter>
            <FooterTxt
              onClick={() => {
                setModalOption('groupjoin');
              }}
              bgcolor={bgcolor}
              color={color}
            >
              {bottomTxt}
            </FooterTxt>{' '}
            {/* 참여하기 */}
          </Campaignfooter>
        ) : (
          <Campaignfooter position="relative">
            <FooterTxtCancle
              onClick={() => {
                join.role === 'admin'
                  ? setModalShow(true)
                  : setModalOption(leaveModal);
              }}
              showModalNext={showModalNext}
            >
              {bottomTxtafer}
            </FooterTxtCancle>
          </Campaignfooter>
        )
      ) : //member가 아닐때
      showModalNext ? (
        <Campaignfooter position="relative">
          <FooterTxtCancle
            onClick={() => {
              setModalOption(leaveModal);
            }}
            showModalNext={showModalNext}
          >
            {bottomTxtafer}
          </FooterTxtCancle>
        </Campaignfooter>
      ) : (
        <Campaignfooter>
          <FooterTxt
            onClick={() => {
              userInfo.isLogin
                ? setModalOption('groupjoin')
                : setShowModal(true);
            }}
            bgcolor={bgcolor}
            color={color}
          >
            {bottomTxt}
          </FooterTxt>{' '}
          {/* 참여하기 */}
        </Campaignfooter>
      )}
      <ModalPath
        setShowModal={setShowModal}
        showModal={showModal}
        subtitle={'로그인이 필요해요'}
        path={'/social'}
        // submitClick={afterShow}
      />
    </>
  );
}


const Campaignfooter = styled.div`
  position: fixed;
  position: ${({ position }) => position};
  bottom: 0;
  left: 0;
  width: 100%;
  height: calc(100vw * (56 / 375));
  z-index: 200;
`;
const FooterTxt = styled.button`
  width: 100%;
  font-size: calc(100vw * (18 / 375));
  font-weight: bold;
  line-height: calc(100vw * (56 / 375));
  letter-spacing: calc(100vw * (0.25 / 375));
  text-align: center;
  color: #4e4e4e;
  color: ${(props) => props.color};
  background-color: #ffcf19;
  background-color: ${(props) => props.bgcolor};
`;
const FooterTxtCancle = styled(FooterTxt)`
  color: #fff;
  background-color: #4e4e4e;
`;
